import { addDays, isAfter, isBefore } from 'date-fns'

import { MonthlyCalendarEvent } from '../monthly-calendar/types'

export const getEventForDay = (calendarEvents: MonthlyCalendarEvent[], day: Date) => {
  return calendarEvents
    .filter(
      (event) =>
        isBefore(day, event.endDate) && // Ensure the day is before or equal to endDate
        isAfter(day, addDays(event.startDate, -1)) // Ensure the day is after or equal to startDate
    )
    .sort((a, b) => a.startDate.getTime() - b.startDate.getTime())
    .pop()
}
